import { useEffect, memo } from 'react'
import { isEmpty } from 'lodash'

import { useAppDispatch, useAppSelector } from 'redux/Hook'
import FilterBuilder from 'components/Reporting/Overview/FilterBuilder'
import { fetchHubs } from 'redux/thunks/Hubs'
import { fetchPages } from 'redux/thunks/Pages'
import { fetchParticipantGroups } from 'redux/thunks/ParticipantGroups'
import { fetchProjectTags } from 'redux/thunks/ProjectTags'
import { fetchProjects } from 'redux/thunks/Projects'
import { FILTER_LIST } from 'components/Reporting/Overview/FilterBuilder/List'
import StakeHolderFilterBuilder from 'components/Reporting/StakeholderDashboard/FilterBuilder'
import useFilterSet from 'containers/Reporting/Shared/Filters/UseFilterSet'
import { fetchEthnicity } from 'redux/slices/Ethnicity'
import { fetchGender } from 'redux/slices/Gender'
import { fetchFilterLocations } from 'redux/thunks/Locations'

const ReportingDashboardFilter = (props: any) => {
  const {
    onSaveFilterSet,
    filterSetResult,
    handleMenuItemClick,
    handleRenameSelection,
    handleDeleteSelection,
    selectedIndex,
    onClearFilterSelection,
  } = useFilterSet()
  const globalDispatch = useAppDispatch()
  const { children, isSharedDashboard = false } = props

  const {
    hubs: { data: hubs },
    pages: { data: pages },
    participantGroups: { data: prmGroups },
    filterLocations: { data: filterLocations },
    projects: { data: projects },
    projectTags: { data: projectTags },
    filterBuilder: { selectedFilters },
    ethnicity: { data: ethnicity },
    gender: { data: gender },
  }: any = useAppSelector((state) => state)

  const isFilterAddedAndNonEmpty = (filterName: string, data: any) =>
    isEmpty(data) && selectedFilters?.find((f: any) => f.name === filterName)

  useEffect(() => {
    const projectParams = {
      assigned: true,
      filterable: true,
      per_page: 999,
      filters: { sort: { name: 'asc' } },
    }

    const filters = FILTER_LIST.map((f: any) => f.name)
    filters.forEach((filter) => {
      switch (filter) {
        case 'hub':
          isFilterAddedAndNonEmpty('hub', hubs) && globalDispatch(fetchHubs())
          break
        case 'page':
          isFilterAddedAndNonEmpty('page', pages) &&
            globalDispatch(fetchPages())
          break
        case 'projects':
          isFilterAddedAndNonEmpty('projects', projects) &&
            globalDispatch(fetchProjects(projectParams))
          break
        case 'projectTag':
          isFilterAddedAndNonEmpty('projectTag', projectTags) &&
            globalDispatch(fetchProjectTags({ name: 'asc' }))
          break
        case 'participantsGroups':
          isFilterAddedAndNonEmpty('participantsGroups', prmGroups) &&
            globalDispatch(fetchParticipantGroups())
          break
        case 'dashboardLocation':
          isFilterAddedAndNonEmpty('dashboardLocation', filterLocations) &&
            globalDispatch(fetchFilterLocations())
          break
        case 'ethnicity':
          isFilterAddedAndNonEmpty('ethnicity', ethnicity) &&
            globalDispatch(fetchEthnicity())
          break
        case 'gender':
          isFilterAddedAndNonEmpty('gender', gender) &&
            globalDispatch(fetchGender())
          break
        default:
          break
      }
    })
  }, [selectedFilters])

  const filterBuilderProps = {
    onClearFilter: onClearFilterSelection,
    onSaveFilterSet,
    filterSetResult,
    handleMenuItemClick,
    handleRenameSelection,
    handleDeleteSelection,
    selectedIndex,
    isSharedDashboard,
  }

  return (
    <>
      {isSharedDashboard ? (
        <StakeHolderFilterBuilder isSharedDashboard={isSharedDashboard} />
      ) : (
        <FilterBuilder {...filterBuilderProps} />
      )}
      {children}
    </>
  )
}

export default memo(ReportingDashboardFilter)
